export default __webpack_public_path__ + "static/media/learose5-1920w.992ecbee.png";